_collow.components.Pagination = class Pagination extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  pages;
  currentPage = 1;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(
      document.body,
      ["_collow.amount-pages", "_collow.pagination-update"],
      this.renderPagination
    );

    this.listen(
      document.body,
      "_collow.pagination-change-amount",
      ({ detail }) => {
        elements.amountElements.value = detail.studentsPerPage;
        elements.amountElements.disabled = true;
      }
    );
  }

  renderPagination = ({ detail }) => {
    if (detail?.pages) this.pages = detail.pages;
    this.currentPage = detail.currentPage;

    switch (detail.currentPage) {
      case 0:
      case 1:
        this.setActive(this.elements.pageOne);
        break;
      case 2:
        if (this.pages == 2) this.setActive(this.elements.currentPage);
        else this.setActive(this.elements.previousPage);
        break;
      case 3:
        this.setActive(this.elements.currentPage);
        break;
      default:
        if (this.pages - 2 == detail.currentPage) {
          this.setActive(this.elements.currentPage);
          break;
        }
        if (this.pages - 1 == detail.currentPage) {
          this.setActive(this.elements.currentPage);
          break;
        }
        if (this.pages == detail.currentPage) {
          this.setActive(this.elements.lastPage);
          break;
        }
        this.setActive(this.elements.currentPage);
    }

    this.setValues(detail.currentPage);
    this.clickListener(true);
    if (this.currentPage) this.elements.pageInput.value = this.currentPage;
    this.elements.amountElements.disabled = false;
    this.elements.container.dataset.pages = this.pages ?? 1;

    // set which dataset on which everything is visible
    let page = this.currentPage;
    if (this.currentPage == this.pages) page = "last";
    if (this.currentPage == this.pages - 1) page = "single-last";
    if (this.currentPage == this.pages - 2) page = "two-from-last";
    this.elements.container.dataset.currentPage = page;
  };

  setActive = (el) => {
    [
      this.elements.pageOne,
      this.elements.previousPage,
      this.elements.currentPage,
      this.elements.nextPage,
      this.elements.lastPage,
    ].forEach((el) => el.removeAttribute("data-page-active"));
    el.dataset.pageActive = true;
  };

  setValues = (value) => {
    if (!value) return;
    let number = +value;
    if (value == 2) number += 1;
    if (value == 1 && this.pages > 2) number += 2;
    if (value == 1 && this.pages < 3) number += 1;
    if (value == this.pages) number -= 1;

    const { previousPage, currentPage, nextPage, lastPage } = this.elements;
    previousPage.textContent = number - 1;
    currentPage.textContent = number;
    nextPage.textContent = number + 1;
    lastPage.textContent = this.pages;
  };

  clickListener = (state) => {
    [
      this.elements.pageOne,
      this.elements.previousPage,
      this.elements.currentPage,
      this.elements.nextPage,
      this.elements.lastPage,
    ].forEach((el) =>
      this[state ? "listen" : "unlisten"](el, "click", this.numberClickHandler)
    );

    this[state ? "listen" : "unlisten"](
      this.elements.next,
      "click",
      this.nextClick
    );
    this[state ? "listen" : "unlisten"](
      this.elements.prev,
      "click",
      this.prevClick
    );
    this[state ? "listen" : "unlisten"](
      this.elements.pageInput,
      "keyup",
      this.inputChange
    );

    this[state ? "listen" : "unlisten"](
      this.elements.amountElements,
      "change",
      this.studentsPerPageChange
    );
  };

  numberClickHandler = ({ target }) => {
    this.currentPage = +target.textContent;
    this.clickListener(false);
    this.dispatch(this.root, "_collow.pagination-update", [
      "currentPage",
      this.currentPage,
    ]);
  };

  nextClick = () => {
    if (this.pages >= this.currentPage + 1) {
      this.clickListener(false);
      this.dispatch(this.root, "_collow.pagination-update", [
        "currentPage",
        this.currentPage + 1,
      ]);
    }
  };

  prevClick = () => {
    if (1 <= this.currentPage - 1) {
      this.clickListener(false);
      this.dispatch(this.root, "_collow.pagination-update", [
        "currentPage",
        this.currentPage - 1,
      ]);
    }
  };

  inputChange = ({ target }) => {
    const value = +target.value;
    if (!value || value > this.pages) {
      target.value = "";
      return;
    }
    this.clickListener(false);
    this.dispatch(this.root, "_collow.pagination-update", [
      "currentPage",
      value,
    ]);
  };

  studentsPerPageChange = ({ target }) => {
    const value = +target.value;
    if (!value) {
      target.value = 10;
      return;
    }
    this.clickListener(false);
    this.dispatch(this.root, "_collow.pagination-students-per-page", [
      "studentsPerPage",
      value,
    ]);
  };
};
